import moment from 'moment'
import { IGeneratingObject } from '../../store/generators/IGeneratingObject'
import { EUserType } from '../../constants/approval'

export const MainInfoConfig = (generatorInfo: IGeneratingObject, dictionaries, t?: any) => {
    const {
        productionModesMap,
        regionsMap,
        ownershipsMap,
        aidsMap,
        fuelMap,
        fullRenewableEnergyTypesMap,
        fullGenCodeOptions,
    } = dictionaries

    const { user_type, company_name_short, last_name, first_name, middle_name, uid } =
        generatorInfo.go_owner

    const goOwnerName =
        user_type === EUserType.UrLico
            ? company_name_short
            : user_type === EUserType.IP
            ? `ИП ${last_name} ${first_name} ${middle_name}`
            : `${last_name} ${first_name} ${middle_name}`

    return {
        visibleInfo: [
            {
                name: t ? t('detailedCard.energyMarket') : 'Рынок ЭЭ',
                value: generatorInfo.is_for_retail
                    ? t
                        ? t('detailedCard.energyMarketRetail')
                        : 'Розничный рынок электроэнергии'
                    : t
                    ? t('detailedCard.energyMarketWholesale')
                    : 'Оптовый рынок электроэнергии',
            },
            {
                name: t ? t('detailedCard.GOType') : 'Тип ГО',
                value: `${
                    generatorInfo.go_type_id === 1
                        ? t
                            ? t('detailedCard.qualifiedGOType')
                            : 'Квалифицированный генерирующий объект'
                        : t
                        ? t('detailedCard.registeredGOType')
                        : 'Зарегистрированный генерирующий объект'
                }`,
            },
            {
                name: t ? t('detailedCard.uniqueGOCode') : 'Уникальный код ГО',
                value: generatorInfo.generator_pub_id,
                isTag: true,
            },
            {
                name: t ? t('detailedCard.generationCode') : 'Код ГТП генерации',
                value: generatorInfo.point_delivery_code,
                isTag: true,
            },
            {
                name: t ? t('detailedCard.consumptionCode') : 'Код ГТП потребления',
                value: generatorInfo.point_delivery_code_consuming,
                isTag: true,
            },
            {
                name: t ? t('detailedCard.GOCode') : 'Код ГО',
                value: generatorInfo.go_code,
                isTag: true,
            },
            {
                name: t ? t('detailedCard.tco') : 'ТСО',
                value: generatorInfo.tso?.company_name_short,
            },
            {
                name: t ? t('detailedCard.gp') : 'ГП',
                value: generatorInfo.gp?.company_name_short,
            },
            {
                name: t ? t('detailedCard.GOLocation') : 'Местонахождение ГО',
                value: [
                    t ? t('detailedCard.russianFederation') : 'Российская Федерация',
                    regionsMap.get(generatorInfo.region_id),
                    generatorInfo.address_index,
                    generatorInfo.city,
                    generatorInfo.street,
                    generatorInfo.house,
                    generatorInfo.housing,
                    generatorInfo.building,
                    generatorInfo.address_info,
                ]
                    .filter(Boolean)
                    .join(', '),
            },
            {
                name: t ? t('detailedCard.latitude') : 'Координаты (широта)',
                value: generatorInfo.geo_lat,
            },
            {
                name: t ? t('detailedCard.longitude') : 'Координаты (долгота)',
                value: generatorInfo.geo_lon,
            },
            {
                name: t
                    ? t('detailedCard.isGreenEnergy')
                    : 'Отнесение ГО к возобновляемой генерации и (или) низкоуглеродной генерации по итогам квалификации генерирующего объекта.',
                value: fullGenCodeOptions.get(generatorInfo.renewable_energy_type_id),
            },
            {
                name: t ? t('detailedCard.localizationDegree') : 'Показатель степени локализации',
                value: generatorInfo.localization_degree
                    ? //                    ? generatorInfo.localization_degree + '%'
                      generatorInfo.localization_degree
                    : undefined,
            },
            {
                name: t
                    ? t('detailedCard.exportRate')
                    : 'Показатель экспорта промышленной продукции',
                value: generatorInfo.export_rate_of_industrial_products
                    ? generatorInfo.export_rate_of_industrial_products + '%'
                    : undefined,
            },
            {
                name: t ? t('detailedCard.qualificationCategory') : 'Квалификационная категория',
                value: fullRenewableEnergyTypesMap.get(generatorInfo.renewable_energy_type_id),
            },
            {
                name: t ? t('detailedCard.fuelTypes') : 'Типы топлива',
                value: generatorInfo.fuel_ids?.map((fuel_id) => fuelMap.get(fuel_id)).join('; '),
            },
            {
                name: t
                    ? t('detailedCard.fuelRenewableTypes')
                    : 'Виды возобновляемых источников энергии и иные виды топлива, используемые для производства электрической энергии, либо указание на то, что генерирующий объект является атомной электростанцией',
                value: generatorInfo.renewable_energy_type_description,
            },
            {
                name: t ? t('detailedCard.installedPower') : 'Установленная мощность',
                value:
                    (generatorInfo.power / 1000).toLocaleString() +
                    ` ${t ? t('detailedCard.scale3') : 'МВт'}`,
            },
            {
                name: t ? t('detailedCard.GOStartDate') : 'Дата ввода ГО в эксплуатацию',
                value: generatorInfo.comissioning_date
                    ? moment(generatorInfo.comissioning_date).format('DD.MM.YYYY')
                    : undefined,
            },
            {
                name: t ? t('detailedCard.productionMode') : 'Режим производства',
                value: productionModesMap.get(generatorInfo.production_mode_id),
            },
            {
                name: t ? t('detailedCard.ownerGrounds') : 'Основания владения',
                value: ownershipsMap.get(generatorInfo.ownership_id),
            },
            {
                name: t ? t('detailedCard.GOOwner') : 'Владелец ГО',
                value: goOwnerName,
                href: `/owner/${uid}`,
            },
            {
                name: t ? t('detailedCard.aidProgram') : 'Программа поддержки',
                value: aidsMap.get(generatorInfo.aid_id),
            },
            {
                name: t
                    ? t('detailedCard.installationPower')
                    : 'Установленная мощность и дата ввода в эксплуатацию электроустановок в составе ГО',
                value: generatorInfo.electrical_installations_power,
            },
        ],
        hiddenInfo: [
            {
                name: t
                    ? t('detailedCard.qualificationNumber')
                    : '№ квалификационного свидетельства',
                value: generatorInfo.qualification_number,
                noMargin: true,
            },
            {
                name: t ? t('detailedCard.qualificationDate') : 'Дата квалификации',
                value: generatorInfo.qualification_date
                    ? moment(generatorInfo.qualification_date).format('DD.MM.YYYY')
                    : undefined,
            },
            {
                name: t
                    ? t('detailedCard.qualificationPoint')
                    : 'Отметка о выдаче дубликата квалификационного свидетельства',
                value: generatorInfo.qualification_point,
            },
            {
                name: t ? t('detailedCard.lastCheckDate') : 'Дата последней проверки',
                value: generatorInfo.last_check_date
                    ? moment(generatorInfo.last_check_date).format('DD.MM.YYYY')
                    : undefined,
            },
        ],
    }
}

export const ownerInfoConfig = {
    visibleInfo: [
        {
            name: 'Полное наименование',
            value: 'Общество с ограниченной ответственностью «Зета Солар»',
        },
        {
            name: 'Юридический адрес',
            value: '295017, Республика Крым, г. Симферополь, ул. Рубцова, д. 44А, офис 5',
        },
        {
            name: 'Почтовый адрес',
            value: '295017, Республика Крым, г. Симферополь, ул. Рубцова, д. 44А, офис 5',
        },
        {
            name: 'Телефон, факс',
            value: '8(3652)-714-010',
        },
        {
            name: 'E-mail, сайт',
            value: 'v.zolotarev@powerservices.ru',
        },
        {
            name: 'ИНН',
            value: '9102064730',
        },
    ],
    hiddenInfo: [
        {
            name: 'Сведения о должностном лице НП "Совет рынка", внесшим запись в реестр',
            value: 'А.В. Чечуров, начальник Департамента аудита и сертификации электрических станций Управления аудита и технологической экспертизы',
            noMargin: true,
        },
        {
            name: 'Основание для внесения записи в реестр',
            value: 'Решение Наблюдательного Совета Ассоциации "НП Совет рынка" о внесении записи в Реестр квалифицированных генерирующих объектов от 22.06.2017 (протокол № 14/2017 от 22 июня 2017 года)',
        },
    ],
}

export const detailedOwnerInfoConfig = {
    visibleInfo: [
        {
            name: 'Полное наименование',
            value: 'Общество с ограниченной ответственностью «Зета Солар»',
        },
        {
            name: 'Юридический адрес',
            value: '295017, Республика Крым, г. Симферополь, ул. Рубцова, д. 44А, офис 5',
        },
        {
            name: 'Почтовый адрес',
            value: '295017, Республика Крым, г. Симферополь, ул. Рубцова, д. 44А, офис 5',
        },
        {
            name: 'Телефон, факс',
            value: '8(3652)-714-010',
        },
        {
            name: 'E-mail, сайт',
            value: 'v.zolotarev@powerservices.ru',
        },
        {
            name: 'Руководитель',
            value: 'Генеральный директор Семеновская Ольга Сергеевна',
        },
        {
            name: 'Наименование гос. органа, осуществившего регистрацию ЮЛ в ЕГРЮЛ',
            value: 'Инспекция Федеральной налоговой службы по г. Симферополю',
        },
        {
            name: 'ОГРН',
            value: '1149102172581',
        },
        {
            name: 'Дата регистрации ЮЛ в ЕГРЮЛ',
            value: '24.12.2014',
        },
        {
            name: 'ИНН',
            value: '9102064730',
        },
        {
            isDivider: true,
            noMargin: true,
        },
        ...ownerInfoConfig.hiddenInfo,
    ],
}
